/* EVENSKYN blog top-100 job, 10 Oct 2026 (v6). Three corrections that need the drawn layout, so they cannot be
   written as CSS. Stored article HTML is not changed, and without this script the page is what it was before.

   1. Diagrams. A diagram drawn as inline SVG scales with the column, so on a phone its labels fell to 3 to 6 px
      (measured at 320 and 390 px on the three most-read guides). When the smallest label would draw under 6.5 px,
      the diagram gets a sideways scroller at the width where that label is 10 px, with a note above it, a faded
      right edge until its end is reached, and keyboard access. The scroller is used only where it can draw the
      diagram at least 1.4 times larger than the column would (it never goes past 900 px): with less to gain, a
      whole diagram with small labels is the better picture, so from about 640 px of column width the diagram is
      drawn whole, as before.

   2. Rows. theme.css gives every block that follows another one inside .prose a top margin (its "* + div" rule).
      In a grid or flex row that pushes each card after the first one down by that amount, so the cards of a row
      stop lining up (21 of the 100 most-read guides, 208 rows at 820 and 1440 px, measured 10 Oct 2026). Where a
      row shows exactly that pattern (the first item has no top margin, a later item on the same line has one),
      the later item's top margin is set to 0. Read again after a resize, because a row on a desktop is often a
      stack on a phone, and a stack keeps its spacing. One more case: a grid that draws its dividers as a row gap
      of 1 or 2 px over a coloured background. There the margin turned every divider after the first row into a
      13 to 17 px band, so in such a grid every item's margin goes, whatever row it is in.

   3. Table hints. The frame prints "Scroll sideways to see the whole table." only under a table it wrapped
      itself, and only if that table overflowed when the page loaded. A table inside a scroller the article brought
      with it got no hint, so on a phone its last columns were simply missing (all 8 tables of the LED mask
      comparison, both tables of the eye patch comparison), and under a tall table the frame's line came a
      thousand pixels after the cut-off columns. Every table that overflows its scroller now has the line above
      it, shown while it overflows by more than 12 px; the frame's line under the table is hidden. A table whose
      caption already says to scroll keeps only its own words. A table that is its own scroller (display block
      with overflow) is treated the same way and can take keyboard focus while it overflows. The line takes over
      the top margin of the table's box, so it sits on the table and not a margin above it, and on a dark or
      mid-toned block it is drawn white or black, whichever reads, instead of the grey meant for light paper. */
(function () {
  var MIN = 6.5, GOAL = 10, CAP = 900, GROW = 1.4;
  function labels(svg) {
    var vb = svg.viewBox && svg.viewBox.baseVal;
    if (!vb || vb.width < 300) return null;
    var texts = svg.querySelectorAll('text');
    if (texts.length < 3) return null;
    var min = Infinity;
    for (var i = 0; i < texts.length; i++) {
      if (!texts[i].textContent.trim()) continue;
      var fs = parseFloat(getComputedStyle(texts[i]).fontSize);
      if (fs && fs < min) min = fs;
    }
    return isFinite(min) ? { vbw: vb.width, min: min } : null;
  }
  function scrolls(el, stop) {
    for (var p = el.parentElement; p && p !== stop; p = p.parentElement) {
      if (p.classList.contains('lrn-fw')) continue;
      var ox = getComputedStyle(p).overflowX;
      if (ox === 'auto' || ox === 'scroll') return true;
    }
    return false;
  }
  function lum(el, stop) {
    for (var p = el; p; p = p.parentElement) {
      var cs = getComputedStyle(p), img = cs.backgroundImage !== 'none', src = img ? cs.backgroundImage : cs.backgroundColor;
      var a = src.indexOf('rgb'), b = a < 0 ? -1 : src.indexOf('(', a), e = b < 0 ? -1 : src.indexOf(')', b);
      if (e > 0) {
        var v = src.slice(b + 1, e).split(/[ ,]+/).map(parseFloat).filter(function (x) { return x === x; });
        if (v.length > 2 && !(v.length > 3 && v[3] < 0.5)) {
          var c = v.slice(0, 3).map(function (x) { x /= 255; return x <= 0.03928 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4); });
          return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
        }
      } else if (img) return 1;
      if (p === stop) break;
    }
    return 1;
  }
  function tone(note, stop) {
    var l = lum(note.parentElement, stop);
    if (l >= 0.69) note.style.removeProperty('color');
    else note.style.setProperty('color', l < 0.18 ? '#fff' : '#000', 'important');
  }
  function fit(svg, prose) {
    var wrap = svg.parentElement && svg.parentElement.classList.contains('lrn-fw') ? svg.parentElement : null;
    if (wrap) { svg.style.width = ''; svg.style.minWidth = ''; }
    var s = labels(svg);
    if (!s || scrolls(svg, prose)) return;
    var w = svg.getBoundingClientRect().width;
    if (w < 160) return;
    var need = Math.min(CAP, Math.ceil(s.vbw * GOAL / s.min));
    var small = s.min * w / s.vbw < MIN && need >= w * GROW;
    var note = wrap && wrap.previousElementSibling && wrap.previousElementSibling.classList.contains('lrn-fw-n') ? wrap.previousElementSibling : null;
    if (!small) {
      if (wrap) { wrap.removeAttribute('tabindex'); wrap.removeAttribute('role'); wrap.removeAttribute('aria-label'); wrap.style.overflowX = 'visible'; wrap.style.boxShadow = 'none'; }
      if (note) note.hidden = true;
      return;
    }
    if (!wrap) {
      wrap = document.createElement('div'); wrap.className = 'lrn-fw';
      svg.parentNode.insertBefore(wrap, svg); wrap.appendChild(svg);
      note = document.createElement('p'); note.className = 'lrn-fw-n'; note.textContent = 'Scroll sideways to see the whole diagram.';
      wrap.parentNode.insertBefore(note, wrap);
      wrap.addEventListener('scroll', function () { wrap.classList.toggle('is-end', wrap.scrollLeft + wrap.clientWidth >= wrap.scrollWidth - 4); });
    }
    wrap.style.overflowX = ''; wrap.style.boxShadow = '';
    wrap.setAttribute('tabindex', '0'); wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', 'Diagram. Scroll sideways to see all of it.');
    if (note) { note.hidden = false; tone(note, prose); }
    svg.style.width = need + 'px'; svg.style.minWidth = need + 'px';
  }
  function rows(prose) {
    var i, k, old = prose.querySelectorAll('[data-lrn-row]');
    for (i = 0; i < old.length; i++) { old[i].style.marginTop = ''; old[i].removeAttribute('data-lrn-row'); }
    var list = prose.querySelectorAll('div,section,ul,ol'), fix = [];
    for (i = 0; i < list.length; i++) {
      var kids = list[i].children;
      if (kids.length < 2) continue;
      var cs = getComputedStyle(list[i]), d = cs.display, gap = d.indexOf('grid') < 0 ? 0 : parseFloat(cs.rowGap) || 0;
      if (d.indexOf('grid') < 0 && (d.indexOf('flex') < 0 || cs.flexDirection.indexOf('column') === 0)) continue;
      if ((parseFloat(getComputedStyle(kids[0]).marginTop) || 0) > 0.5) continue;
      var r0 = kids[0].getBoundingClientRect();
      if (!r0.width) continue;
      for (k = 1; k < kids.length; k++) {
        var mt = parseFloat(getComputedStyle(kids[k]).marginTop) || 0;
        if (mt < 3) continue;
        var r = kids[k].getBoundingClientRect();
        if ((gap > 0 && gap <= 2) || (Math.abs(r.left - r0.left) > 8 && Math.abs(r.top - mt - r0.top) < 2)) fix.push(kids[k]);
      }
    }
    for (i = 0; i < fix.length; i++) { fix[i].style.marginTop = '0'; fix[i].setAttribute('data-lrn-row', ''); }
  }
  function hints(prose) {
    var tables = prose.querySelectorAll('table'), seen = [];
    for (var i = 0; i < tables.length; i++) {
      var t = tables[i], sc = null;
      for (var p = t; p && p !== prose; p = p.parentElement) {
        var cs = getComputedStyle(p), ox = cs.overflowX;
        if ((ox === 'auto' || ox === 'scroll') && (p !== t || cs.display.indexOf('table') < 0)) { sc = p; break; }
      }
      if (!sc || seen.indexOf(sc) >= 0) continue;
      seen.push(sc);
      var host = sc === t && t.parentElement !== prose && t.parentElement.classList.contains('lrn-tw') ? t.parentElement : sc;
      var over = sc.scrollWidth > sc.clientWidth + 12, prev = host.previousElementSibling, next = host.nextElementSibling;
      if (next && next.classList.contains('lrn-tw-n') && !next.hasAttribute('data-lrn-hint')) next.hidden = true;
      if (sc === t) {
        if (over && !t.hasAttribute('tabindex')) { t.setAttribute('tabindex', '0'); t.setAttribute('data-lrn-tab', ''); }
        if (!over && t.hasAttribute('data-lrn-tab')) { t.removeAttribute('tabindex'); t.removeAttribute('data-lrn-tab'); }
      }
      var mine = prev && prev.hasAttribute('data-lrn-hint') ? prev : null;
      if (!mine) {
        if (!over) continue;
        var cap = sc.querySelector('caption');
        if (cap && /scroll|swipe/i.test(cap.textContent)) continue;
        mine = document.createElement('p'); mine.className = 'lrn-tw-n lrn-tw-a'; mine.setAttribute('data-lrn-hint', '');
        mine.textContent = 'Scroll sideways to see the whole table.';
        host.parentNode.insertBefore(mine, host);
      }
      mine.hidden = true;
      if (!over) continue;
      var mt = parseFloat(getComputedStyle(host).marginTop) || 0;
      if (mt > 12) mine.style.setProperty('margin-top', mt + 'px', 'important'); else mine.style.removeProperty('margin-top');
      tone(mine, prose);
      mine.hidden = false;
    }
  }
  function run() {
    var prose = document.getElementById('lrn-body');
    if (!prose) return;
    var list = prose.querySelectorAll('svg');
    for (var i = 0; i < list.length; i++) { try { fit(list[i], prose); } catch (e) {} }
    try { rows(prose); } catch (e) {}
    try { hints(prose); } catch (e) {}
  }
  var timer;
  run();
  document.addEventListener('DOMContentLoaded', function () { setTimeout(run, 0); });
  window.addEventListener('load', run);
  window.addEventListener('resize', function () { clearTimeout(timer); timer = setTimeout(run, 200); });
})();